const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const getToken = () => {
  try {
    return localStorage.getItem('edswot_token');
  } catch {
    return null;
  }
};

const buildHeaders = (isFormData = false) => {
  const h = { Accept: 'application/json' };
  if (!isFormData) h['Content-Type'] = 'application/json';
  const token = getToken();
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
};

const handleResponse = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(data.message || 'Request failed');
    error.status = res.status;
    error.errors = data.errors || {};
    error.data = data;
    throw error;
  }
  return data;
};

export const api = {
  get: (path) =>
    fetch(`${BASE_URL}${path}`, { headers: buildHeaders() }).then(handleResponse),

  post: (path, body) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: buildHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),

  put: (path, body) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'PUT',
      headers: buildHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),

  del: (path) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'DELETE',
      headers: buildHeaders(),
    }).then(handleResponse),

  postForm: (path, formData) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: buildHeaders(true),
      body: formData,
    }).then(handleResponse),

  putForm: (path, formData) =>
    fetch(`${BASE_URL}${path}`, {
      method: 'PUT',
      headers: buildHeaders(true),
      body: formData,
    }).then(handleResponse),
};
